import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'nc-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.less']
})
export class PdfViewerComponent implements OnChanges {
  @Input() ncUrl: string = '';
  viewerUrl!: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['ncUrl']) {
      this.updateViewerUrl();
    }
  }

  private updateViewerUrl() {
    const url = `assets/pdfjs-dist-build/web/viewer.html?file=${encodeURIComponent(this.ncUrl)}`;
    this.viewerUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
